import { render, staticRenderFns } from "./ClientProductSearch.vue?vue&type=template&id=9517c5fa&scoped=true&"
import script from "./ClientProductSearch.vue?vue&type=script&lang=ts&"
export * from "./ClientProductSearch.vue?vue&type=script&lang=ts&"
import style0 from "./ClientProductSearch.vue?vue&type=style&index=0&id=9517c5fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9517c5fa",
  null
  
)

export default component.exports